import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, ShieldCheck } from 'lucide-react';
const BOX_IMG = 'https://cdn.magicpatterns.com/uploads/3XUSYHUsLox53cS6HwHc5d/ChatGPT-Image-1-jul-2026_-09_08_36-p.m..webp';
export function Hero() {
  return <section className="pt-8 pb-6 px-4 sm:px-6 bg-cream text-center border-b-4 border-ivory" data-id="element-94">
      <div className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-gold/10 border border-gold/30 text-petrol font-body font-bold text-xs sm:text-sm mb-4 shadow-sm" data-id="element-95">
        <span className="text-base leading-none" data-id="element-96">✨</span>
        <span className="tracking-widest uppercase" data-id="element-97">
          SISTEMA DI ALLENAMENTO VALIDATO
        </span>
      </div>

      <h1 className="text-3xl sm:text-5xl md:text-6xl font-heading font-bold text-petrol leading-[1.1] mb-3" data-id="element-98">
        Il Sistema Completo 6 in 1 per Professionisti del Fitness Senior
      </h1>

      <p className="text-base sm:text-xl text-graphite font-subheading font-semibold leading-snug mb-5 max-w-2xl mx-auto" data-id="element-99">
        Risparmia ore di pianificazione, offri sessioni più sicure e aiuta gli
        adulti maggiori a muoversi con fiducia — senza creare lezioni da zero.
      </p>

      <div className="inline-block bg-sage text-white px-5 py-2 rounded-md mb-5 shadow-md" data-id="element-100">
        <p className="font-body font-bold text-sm sm:text-base tracking-widest uppercase" data-id="element-101">
          FITNESS SENIOR PRO™ — COFANETTO 6 IN 1
        </p>
      </div>

      <div className="mb-6" data-id="element-102">
        <a href="#pricing" className="block cursor-pointer" data-id="element-103">
          <img src={BOX_IMG} alt="FITNESS SENIOR PRO Cofanetto 6 in 1" className="w-full h-auto object-contain max-w-[300px] sm:max-w-lg mx-auto hover:scale-[1.02] transition-transform duration-300 drop-shadow-2xl" data-id="element-104" />
        </a>
      </div>

      <div className="mb-4 max-w-lg mx-auto" data-id="element-105">
        <CTAButton data-id="element-106">🚀 SÌ, VOGLIO IL MIO SISTEMA ADESSO</CTAButton>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-6 text-xs sm:text-sm text-graphite font-bold" data-id="element-107">
        <div className="flex items-center gap-1.5" data-id="element-108">
          <Star className="w-4 h-4 fill-gold text-gold" data-id="element-109" />
          <span data-id="element-110">4.9/5 — Recensioni professionali verificate</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-111">
          <ShieldCheck className="w-4 h-4 text-sage" data-id="element-112" />
          <span data-id="element-113">Garanzia 7 giorni — Zero rischio</span>
        </div>
      </div>
    </section>;
}